// appsActions.js
import { SET_PROFILE } from './../types/profileConstants'

export function setProfile(profile) {
  return {
    type: SET_PROFILE,
    payload: profile
  }
}
